<template>
  <div>
    <el-card>
      <div>
        <span class="title-text">运单号：{{ detail.waybillNo }}</span>
        <el-divider direction="vertical"></el-divider>
        <span class="title-text">承运商：{{ detail.carrierName }}</span>
        <el-divider direction="vertical"></el-divider>
        <span class="title-text">运单状态：{{ detail.wayBillStatusName }}</span>
        <el-divider direction="vertical"></el-divider>
        <span class="title-text">创建时间：{{ detail.createTime }} </span>
      </div>
      <waybill-detail-table class="mt-3" :tableData="detail.scheduleList" />
    </el-card>
    <el-card class="mt-2">
      <weight-table
        :tableData="detail.weightList"
        :waybillCode="params.code"
        :totPriceWeight="detail.totPriceWeight"
        :transportMode="detail.transportMode"
        :weightDisable="weightDisable"
        @reload="reload"
      />
    </el-card>
  </div>
</template>
<script>
import WaybillDetailTable from './waybill-detail-table.vue'
import WeightTable from './weight-table'
export default {
  name: 'carrier-weight-weightRecord-detail-page',
  components: { WaybillDetailTable, WeightTable },
  data() {
    return {
      detail: {},
      weightDisable: false,
    }
  },
  watch: {
    params: {
      handler(params) {
        if (params.code) {
          this.loadData(params.code)
        }
      },
      immediate: true,
    },
  },
  computed: {
    params() {
      return this.$route.params
    },
  },
  methods: {
    loadData(code) {
      this.$api
        .bizWaybillWeightWaybillDetailApi({
          waybillCode: code,
        })
        .then((res) => {
          this.detail = res.body
          const { transportMode } = this.detail
          this.detail.transportMode = transportMode + ''
          if (res.body.wayBillStatus != '0' && res.body.wayBillStatus != '2') {
            this.weightDisable = true
          }
        })
    },
    reload() {
      this.loadData(this.params.code)
    },
  },
}
</script>
<style lang="scss" scoped>
.timeline-timestamp {
  color: gray;
  margin-right: 10px;
}

.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}

.title-text {
  font-size: 15px;
  color: #5a5a5a;
  font-family: 'Muli', sans-serif;
}
</style>
